import {regexEmail} from "utils/utils";

export const EDIT_PROFILE_VALIDATION = {
    name: {
        required: 'Nama wajib diisi',
        format: {
            pattern: /^[a-zA-Z0-9&()_\-:',./\s]*$/,
            message: `Spesial karakter yang diperbolehkan hanya berupa & ( ) - _ : ' , . /`,
        },
        minimum: {
            value: 3,
            message: 'Nama minimal 3 karakter',
        },
    },
    email: {
        required: 'Email wajib diisi',
        format: {
            pattern: regexEmail,
            message: 'Format email tidak sesuai',
        },
    },
    phone_number: {
        minimum: {
            value: 8,
            message: 'Nomor handphone minimal 8 angka',
        },
        format: {
            pattern: /^8[1-9][0-9]*$/,
            message: 'Nomor handphone yang di inputkan belum sesuai',
        },
    },
}

export const EDIT_ADDRESS_VALIDATION = {
    type: { required: 'Nama Alamat wajib diisi' },
    name: {
        required: 'Nama penerima wajib diisi',
        minimum: {
            value: 3,
            message: 'Nama minimal 3 karakter',
        },
    },
    phone_number: {
        required: 'No. Telepon penerima wajib diisi',
        minimum: {
            value: 8,
            message: 'No. Telepon minimal 8 digit',
        },
    },
    detail_address: { required: 'Kota & Kecamatan wajib diisi' },
    zipcode: { required: 'Kode pos wajib diisi' },
    address: { required: 'Alamat lengkap wajib diisi' },
}

export const CREATE_PROFILE_VALIDATION = {
    name: {
        required: 'Nama wajib diisi',
        minimum: {
            value: 3,
            message: 'Nama minimal 3 karakter',
        },
        format: {
            pattern: /^[a-zA-Z0-9&()_\-:',./\s]*$/,
            message: `Spesial karakter yang diperbolehkan hanya berupa & ( ) - _ : ' , . /`,
        },
    },
    email: {
        required: 'Email wajib diisi',
        format: {
            pattern: regexEmail,
            message: 'Format email tidak sesuai',
        },
    },
    phone_number: {
        minimum: {
            value: 8,
            message: 'Nomor handphone minimal 8 angka',
        },
        format: {
            pattern: /^8[1-9][0-9]*$/,
            message: 'Nomor handphone yang di inputkan belum sesuai',
        },
    },
    role: { required: 'Role wajib diisi' },
    password: { required: 'Password wajib diisi' },
}
